import React, { createContext, useContext } from 'react'
import { useFeatureFlag } from '@fs/zion-flags'
import useDynamicNavigation from './hooks/useDynamicNavigation'

const DynamicLinksContext = createContext('dynamicLinksContext')

export function useDynamicLinkContext() {
  return useContext(DynamicLinksContext)
}

function DynamicLinks({ children }) {
  const navigation = useDynamicNavigation()

  return <DynamicLinksContext.Provider value={navigation}>{children}</DynamicLinksContext.Provider>
}

const emptyState = {}
export default function DynamicLinksProvider({ children }) {
  const { isOn: dynamicLinksOn } = useFeatureFlag('home_footer_dynamicLinks')

  if (dynamicLinksOn) {
    return <DynamicLinks>{children}</DynamicLinks>
  }
  return <DynamicLinksContext.Provider value={emptyState}>{children}</DynamicLinksContext.Provider>
}
